import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KpiGrid, StatusChip } from "@/components/kcc/Kpi";
import { Panel, ModuleHeader } from "@/components/kcc/Panel";
import { DataTable, statusToChip } from "@/components/kcc/DataTable";

const IMG = "https://images.unsplash.com/photo-1523660778745-247ed0bcce31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxoZWF2eSUyMGhhdWwlMjB0cnVjayUyMG1pbmluZ3xlbnwwfHx8fDE3ODU2MDk5NzJ8MA&ixlib=rb-4.1.0&q=85";

export default function Maintenance360() {
    const [data, setData] = useState(null);
    const [filter, setFilter] = useState("all");
    useEffect(() => { api.get("/maintenance/overview").then(({ data }) => setData(data)); }, []);
    const rows = (data?.work_orders || []).filter((w) => filter === "all" || w.priority === filter);
    return (
        <div className="space-y-6">
            <ModuleHeader kicker="Maintenance360" title="Work Management & Reliability" description="Corrective, preventive, predictive and shutdown work — planned, scheduled, executed and verified with digital signatures." image={IMG} />
            <KpiGrid kpis={data?.kpis || []} accent="copper" cols={5} />
            <Panel
                title="Work Order Backlog"
                subtitle={`${rows.length} of ${(data?.work_orders || []).length} shown`}
                accent="copper"
                actions={
                    <div className="flex gap-1">
                        {["all", "P1", "P2", "P3", "P4"].map((p) => (
                            <button
                                key={p}
                                onClick={() => setFilter(p)}
                                className={`text-[11px] px-2.5 py-1 rounded border ${filter === p ? "border-kcc-copper text-white bg-kcc-copper/15" : "border-white/10 kcc-text-silver hover:text-white"}`}
                                data-testid={`filter-${p}`}
                            >{p}</button>
                        ))}
                    </div>
                }
            >
                <DataTable
                    columns={[
                        { key: "wo_no", label: "WO #" },
                        { key: "asset_tag", label: "Asset" },
                        { key: "type", label: "Type" },
                        { key: "priority", label: "Priority", render: (r) => <span className={`font-mono-kcc text-xs ${r.priority === "P1" ? "text-kcc-red" : r.priority === "P2" ? "text-kcc-amber" : "kcc-text-silver"}`}>{r.priority}</span> },
                        { key: "description", label: "Description" },
                        { key: "planned_hours", label: "Planned h" },
                        { key: "cost_usd", label: "Cost", render: (r) => `$${r.cost_usd.toLocaleString()}` },
                        { key: "status", label: "Status", render: (r) => <StatusChip status={statusToChip(r.status)}>{r.status}</StatusChip> },
                    ]}
                    rows={rows.slice(0, 40)}
                    testid="wo-table"
                />
            </Panel>
        </div>
    );
}
